var render, staticRenderFns
import script from "./sale_area_item.vue?vue&type=script&lang=js"
export * from "./sale_area_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c36e6bc')) {
      api.createRecord('7c36e6bc', component.options)
    } else {
      api.reload('7c36e6bc', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/sale_area/sale_area_item.vue"
export default component.exports